import { useEffect } from 'react';

const SITE = 'A to Z Movie Database';

export const useDocumentTitle = title => {
  useEffect(() => {
    document.title = title ? `${title} — ${SITE}` : SITE;
  }, [title]);
};
